import React from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Helmet from 'wanderu-component-helmet';
import {
    localize,
    selectLocale,
} from 'wanderu-i18n';

import c2cConfig from '../../../../config/c2c.locale';

function getLocalizedTruncatedPrice(minPrice, i18nMoney) {
    let localizedPrice = i18nMoney(minPrice).getConvertedPrice();
    let truncatedLocalizedPrice;
    if (localizedPrice < 1) {
        truncatedLocalizedPrice = 1;
    } else {
        truncatedLocalizedPrice = Math.round(localizedPrice);
    }

    return i18nMoney(
        truncatedLocalizedPrice,
        i18nMoney.getCurrency(),
    ).format({ maximumFractionDigits: 0, minimumFractionDigits: 0 });
}

function CityToCityMeta(props) {
    const {
        t,
        data,
        i18nMoment,
        i18nMoney,
        structuredData,
        noIndex,
        ...otherProps
    } = props;

    const description = t('metaPageDescription', {
        currentDate: i18nMoment().format('LL'),
        minPrice: getLocalizedTruncatedPrice(data.cheapestPrice, i18nMoney),
    });
    const title = t('metaPageTitle', {
        minPrice: getLocalizedTruncatedPrice(data.cheapestPrice, i18nMoney),
    });

    // Put the refinement of the supportedLocales config based on the noIndexLocale here
    const supportedLocales = () => {
        const filteredLocales = c2cConfig.supportedLocales.filter((locale) => !otherProps?.noIndexLocale?.includes(locale) ?? false);
        return filteredLocales;
    };

    const indexableLocale = () => {
        const currentLocale = props.locale;
        const isIndexable = !noIndex && (!otherProps?.noIndexLocale?.includes(currentLocale) ?? true);
        // We return a negative here because noIndex is a truthy value (when logic is falsy)
        return !isIndexable;
    };

    return (
        <Helmet
            {...otherProps}
            description={description}
            noIndex={indexableLocale()}
            structuredData={structuredData}
            supportedLocales={supportedLocales()}
            title={title}
        />
    );
}

CityToCityMeta.propTypes = {
    data: PropTypes.object.isRequired,
    canonicalPath: PropTypes.string.isRequired,
    noIndex: PropTypes.bool,
    noIndexLocale: PropTypes.array,
    structuredData: PropTypes.arrayOf(PropTypes.object).isRequired,
    locale: PropTypes.string.isRequired,
};

CityToCityMeta.defaultProps = {
    noIndex: false,
    noIndexLocale: [],
    locale: 'en-us',
};

function mapStateToProps(state) {
    return {
        locale: selectLocale(state),
    };
}

export {
    CityToCityMeta,
};

export default connect(mapStateToProps)(localize(CityToCityMeta, c2cConfig.namespace));
